import type { EditorNode } from "./mapEdit.js";

export function canLink(from: EditorNode, to: EditorNode): boolean {
  return to.id !== from.id && to.y > from.y;
}
